import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { InfoConcat } from 'src/app/models/contactpublicity';
import { RadioService } from 'src/app/services/radio.service';
import { Observable, of, Subscription } from 'rxjs';
import { Radio } from 'src/app/models/radio';
import { ContactpublicityService } from 'src/app/services/contactpublicity.service';
import * as firebase from 'firebase';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnalitycsService } from 'src/app/services/analitycs.service';

@Component({
  selector: 'app-nosotros',
  templateUrl: './nosotros.component.html',
  styleUrls: ['./nosotros.component.scss'],
})
export class NosotrosComponent implements OnInit,OnDestroy {
  timeLine = [
    {
      title: 'MISIÓN',
      year: 'MISIÓN',
      active: true,
      imageMain: 'assets/Recursos/misionNew.jpg',
      image: 'assets/Recursos/misionNew.jpg',
      detail:
        'Ofrecer a nuestros oyentes y clientes un servicio oportuno, de alta calidad y confiabilidad, que opera bajo el compromiso de garantizar una información rigurosa, independiente y plural. Y a nuestros empleados, un ambiente de trabajo cordial, donde se sientan a gusto y puedan prosperar.',
    },
    {
      title: 'VISIÓN',
      year: 'VISIÓN',
      active: false,
      imageMain: 'assets/Recursos/visionnew2.jpg',
      image: 'assets/Recursos/visionnew2.jpg',
      detail:
        'Mantener y mejorar el posicionamiento que Radio Centro ha logrado en la comunidad de tal manera que siga siendo identificada como un REFERENTE en Cochabamba por su calidad y servicio. En la mente de la gente debemos aparecer siempre que se piense en medios de comunicación.',
    },
    {
      title: 'VALORES',
      year: 'VALORES',
      active: false,
      imageMain: 'assets/Recursos/valoresNew.jpg',
      image: 'assets/Recursos/valoresNew.jpg',
      detail:
        'RADIO CENTRO es una muestra de la lucha contra la adversidad, de la exitosa manera de aprovechar el viento a favor, pero ante todo de la entrega de ese grupo humano.',
    },
    {
      title: 'HONESTIDAD',
      year: 'HONESTIDAD',
      active: false,
      imageMain: 'assets/Recursos/honestidadNew.jpg',
      image: 'assets/Recursos/honestidadNew.jpg',
      detail:
        'Nuestro accionar debe ser congruente, conjugando equilibradamente lo que decimos con lo que hacemos. Sabemos que este punto es vital para poder generar confianza y credibilidad en nuestra audiencia. Estos mismos deben estar seguros de que en Grupo Centro, los principios y valores que tenemos encuentran, sin duda alguna, un correlato en la realidad. Cada pequeño acto debe ser parte de un lineamiento y un objetivo más grande.',
    },
    {
      title: 'SOLIDARIDAD',
      year: 'SOLIDARIDAD',
      active: false,
      imageMain: 'assets/Recursos/solidaridad.jpg',
      image: 'assets/Recursos/solidaridad.jpg',
      detail:
        'Como organización, debemos intentar ayudar a grupos vulnerables bajo todos los canales posibles. También debemos manejarnos bajo un principio de solidaridad con otros medios,  movimientos y personas cuyos intereses y principios son afines a Grupo Centro. Estamos seguros que formar redes de  apoyo inteligentes, es una acción que nos ayudará a construir organizaciones e instituciones más fuertes en el futuro.',
    },
    {
      title: 'LEALTAD',
      year: 'LEALTAD',
      active: false,
      imageMain: 'assets/Recursos/loyaltycrop.jpg',
      image: 'assets/Recursos/loyaltycrop.jpg',
      detail:
        'Entendido como un compromiso auténtico con la causa de Grupo Centro, es necesario guiarnos por un principio de fidelidad ante los propios postulados que nos llevaron a iniciar este proyecto. Aunque en algún momento nos toque enfrentar situaciones adversas, siempre debemos asegurarnos que nuestras acciones y nuestro comportamiento estén dedicados enteramente a los principios que tenemos como organización.',
    },
    {
      title: 'TOLERANCIA',
      year: 'TOLERANCIA Y PLURALISMO',
      active: false,
      imageMain: 'assets/Recursos/plural.jpg',
      image: 'assets/Recursos/plural.jpg',
      detail:
        'Los medios de comunicación deben evitar ante todo, difundir noticias e información sesgada. La convivencia armónica entre diferencias es esencial para saber que estamos presentado los distintos lados de una misma historia. Nuestro deber es tratar los datos desde la mayor cantidad de aristas posibles, asegurando el tratamiento correcto de información corroborada y verídica. La tolerancia y el respeto deben primar ante todo. ',
    },
    {
      title: 'HISTORIA: INICIOS',
      year: '5 FEBRERO 1964',
      active: false,
      imageMain: 'assets/Recursos/barrientos.jpg',
      image: 'assets/Recursos/barrientos.jpg',
      detail:
        'RADIO CENTRO es una muestra de la lucha contra la adversidad, de la exitosa manera de aprovechar el viento a favor, pero ante todo de la entrega de ese grupo humano, que decidió llevar adelante el proyecto de ofrecer a Cochabamba una nueva estación radial. El emprendimiento, fue el resultado de la iniciativa y decisión de hombres como Hugo Maldonado, que ya tuvo una experiencia similar con Radio Cochabamba, que fundó, José Oropeza de los Llanos, Ramiro “Patato” Mendez. Victor Aguilar Dorado y Antonio Torrico. En los hechos el génesis de este medio de comunicación, se remonta al segundo semestre de 1964, cuando se concreta el plan, iniciando los trámites de licencia, ante la Dirección de Telecomunicaciones.',
    },
    {
      title: 'HISTORIA: INICIATIVA',
      year: 'INICIATIVA ANTES QUE CAPITAL',
      active: false,
      imageMain: 'assets/Recursos/centro.jpg',
      image: 'assets/Recursos/centro.jpg',
      detail:
        'En tanto aguardaban la autorización, los socios se dieron a la tarea de dotar a la radioemisora de las condiciones técnicas, físicas y administrativas, para comenzar a funcionar, ni bien se hubiese cumplido la formalidad ante  la Dirección de Telecomunicaciones. El primer estudio, fue montado en la calle Santibáñez entre Nataniel Aguirre y Ayacucho. Un equipo de radioaficionados, alquilado, fue adaptado como transmisor, en tanto que los estudios cobraron forma con el aporte de máquinas de escribir, mobiliario y otros artefactos por parte de los entusiastas socios.Una anécdota: los vidrios empleados para la división de los ambientes de operadores y locutores, eran de la misma procedencia que el empleado en el fanal del Santo Sepulcro, obsequio de la esposa del Rey del Estaño. El dueño de la vidriería a la que se encargó el trabajo, lo mantuvo guardado por muchos años, hasta que vio por conveniente utilizarlo.',
    },
    {
      title: 'HISTORIA: LA VERDAD',
      year: 'HORA DE LA VERDAD',
      active: false,
      imageMain: 'assets/Recursos/hora.jpg',
      image: 'assets/Recursos/hora.jpg',
      detail:
        'Cumplidas las formalidades y culminada la fase de instalación de la cabina de transmisión, sala de grabación y montada la “Sala de Prensa”, esta última toda una novedad, pues era una pauta de que la información tendría sitio privilegiado en la programación. Se vio por conveniente iniciar actividades el 4 de febrero de 1964. A las 20 horas, irrumpiría en el éter, el espacio radial, una nueva señal, la de RADIO CENTRO y una característica musical fue elegida, para tan especial momento e identificarla: Exodo. Tal cual había sido establecido, en hora y fecha fijada, en los hogares cochabambinos, comenzó a escucharse: “EXODO”. Tan vibrante y emocionante, como ese: “BUENAS NOCHES RADIOYENTES. INICIAMOS NUESTRAS TRANSMISIONES a cargo de MilivoyEterovicMatenda y Ramiro “Patato” Méndez.',
    },
    {
      title: 'HISTORIA: VALOR',
      year: 'ANTE LA ADVERSIDAD VALOR',
      active: false,
      imageMain: 'assets/Recursos/valorcbCrop.jpg',
      image: 'assets/Recursos/valorcbCrop.jpg',
      detail:
        'A los 4 meses de iniciar  sus emisiones, RADIO CENTRO es  clausurada y se le suspende la licencia. Fue en el gobierno de Victor Paz Estensoro, debido al ejercicio de la libertad de prensa y opinión, que hizo gala desde sus inicios y es aún norma. De ese modo actuaron los socios y trabajadores de la estación radial, convencidos de que era necesario defender a ultranza el proyecto, ante una acción política. Optaron por la huelga de hambre, considerada histórica, debido a que logró el apoyo de las instituciones cochabambinas. Monseñor Walter Rosales, logró que el entonces vicepresidente, René Barrientos, visite el piquete de huelga y se comprometa a revertir la decisión. Otro pasaje, demostrativo de la intolerancia, se registró en 1969 cuando desconocidos, dinamitan la antena de la emisora, dejándola fuera del éter, oportunidad en que se evidenció que CENTRO había llegado para quedarse y vencer toda adversidad.',
    },
    {
      title: 'HISTORIA: COMPROMISO',
      year: 'COMPROMISO CON COCHABAMBA',
      active: false,
      imageMain: 'assets/Recursos/compromisoNewCrop.jpg',
      image: 'assets/Recursos/compromisoNewCrop.jpg',
      detail:
        'En esta retrospectiva, resalta el compromiso de RADIO CENTRO, con el progreso de la región, impulsando activamente proyectos que como el despegue económico, la defensa de los recursos naturales, Misicuni,  salud y educación. A la par de la popularidad que logró, se desarrollaron actividades de impacto social, como la ayuda prestada en la década de los 60 a las víctimas de las inundaciones en Jaihuayco, labor que se concretó con la ayuda del Ejército. Se organizó la distribución de juguetes, estableciendo la efectividad de la relación: CENTRO-EJERCITO. Se organizaron competencias de cochecitos con fines benéficos y de solaz esparcimiento. CENTRO, marca el pulso de los cochabambinos, pero ante todo resume sus sentimientos. Y eso también tiene que ver mucho con la construcción de nuestro queridísimo Cristo de la Concordia, donde Radio Centro tuvo un espacio muy importante.',
    },
  ];

  elegido = this.timeLine[0];

  @HostListener('window:beforeunload', ['$event'])
  unloadAnalytics($event: any) {
    this.analytics.logEvents("refresh: nosotros");
  }

  filacarrusel: any;
  flechaIzquierda: any;
  flechaDerecha: any;
  public isMobile: boolean = false;
  public isMini: boolean = false;
  radios: Observable<Radio[]> = of(null);
  model: InfoConcat = new InfoConcat();
  current_selected = "Ninguno";
  typesOfRadios = ["Radio Universal", "Radio Centro", "Ambas radios", "Redes Sociales","Página Web", "Todas las anteriores"];
  radioElegida = this.typesOfRadios[0];
  radiosAElegir: Radio[];
  myForm: FormGroup;
  id:string="0";
  subscription: Subscription=new Subscription;

  constructor(
    breakpointObserver: BreakpointObserver,
    private radioserv: RadioService,
    private infoServ: ContactpublicityService,
    private _snackBar: MatSnackBar,
    public fb: FormBuilder,
    private analytics: AnalitycsService
  ) {
    this.model = {
      deleted: false,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      email: '',
      message: '',
      name: '',
      nameCompany: '',
      frecuency: null,
    };
    this.subscription.add(breakpointObserver.observe(['(max-width: 992px)']).subscribe((result) => {
      this.isMobile = result.matches;
    }));

    this.subscription.add(breakpointObserver.observe(['(max-width: 768px)']).subscribe((result) => {
      this.isMini = result.matches;
    }));
    this.analytics.logEvents("Nosotros enter");
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.reactiveForm();
  }

  /*Control errores*/
  public errorHandling = (control: string, error: string) => {
    return this.myForm.controls[control].hasError(error);
  }
  submitForm() {
  }
  reactiveForm() {
    this.myForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      empresa: ['', [Validators.required]],
      mensaje: ['', [Validators.required]],
    })
  }
  /*Fin control errores */
  changeText(radio: Radio) {
    this.model.frecuency = { id: radio.id, name: radio.name };
  }

  eligeRadio(i) {
    this.id=i;
    this.radioElegida = this.typesOfRadios[i];
  }

  verificarCorreo() {

    if(this.myForm.invalid)
    {
      this.openSnackBar("Por favor verifique los datos introducidos", "Cerrar");
    }
    else{
      this.model.name=this.myForm.value.name;
      this.model.email=this.myForm.value.email;
      this.model.frecuency={
        name:  this.radioElegida,
        id:    this.id,
      }
      //this.model.frecuency.name=this.radioElegida;
      this.model.nameCompany=this.myForm.value.empresa;
      this.model.message=this.myForm.value.mensaje;

      this.send();
      this.openSnackBar("Datos enviados!", "Cerrar");
      this.myForm.reset();
    }


  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngAfterContentInit() {
    window.scroll(0, 0);
  }
  getElementBackGroundScreen(d: any) {
    this.filacarrusel = d.querySelector('.control-carrusel-nosotros');
    let imagenes = d.querySelector('.imagen');

    this.flechaIzquierda = d.getElementById('flecha-izquierda-nosotros');
    this.flechaDerecha = d.getElementById('flecha-derecha-nosotros');

    this.flechaDerecha.addEventListener('click', () => {
      this.filacarrusel.scrollLeft += this.filacarrusel.offsetWidth;
    });

    this.flechaIzquierda.addEventListener('click', () => {
      this.filacarrusel.scrollLeft -= this.filacarrusel.offsetWidth;
    });
  }

  elegir(el: HTMLElement, num) {
    this.elegido.active = false;

    this.elegido = this.timeLine[num];

    this.elegido.active = true;

    let element = document.getElementById('tpTitulo');
    element.scrollIntoView({ behavior: 'smooth' });
  }
  send() {
    var send = true;
    if (this.model.name.trim().length == 0) {
      send = false;
    }
    if (this.model.email.trim().length == 0) {
      send = false;
    }
    if (!this.model.frecuency) {
      send = false;
    }
    if (this.model.message.trim().length == 0) {
      send = false;
    }
    if (this.model.nameCompany.trim().length == 0) {
      send = false;
    }

    if (send) {
      this.infoServ
        .create(this.model)
        .then(() => {
          alert('Enviado correctamente');
          this.model = {
            deleted: false,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            email: '',
            message: '',
            name: '',
            nameCompany: '',
            frecuency: null,
          };
        })
        .catch(console.log);
    } else {
      alert('Llene todos los campos');
    }
  }
}
